import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import faUp from "icons/regular/up.svg";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { uiActions } from "store/ui/uiSlice";
import { PromptSerializersPromptBook } from "types/serializers";

export default function PromptBookAnonymous({
  promptBook,
}: {
  promptBook: PromptSerializersPromptBook;
}) {
  const dispatch = useDispatch();

  const showLogin = useCallback(() => {
    dispatch(uiActions.toggleLoginVisible("Login"));
  }, []);

  return (
    <Button
      className="flex flex-col items-center group hover:text-indigo-500 dark:hover:text-yellow-400 p-2 border-2 rounded-sm border-transparent dark:hover:border-yellow-400 hover:border-indigo-500 font-bold"
      onClick={showLogin}
    >
      <Icon icon={faUp} size="2xl" />
      {promptBook.answersCount.toLocaleString()}
    </Button>
  );
}
